// extracted by mini-css-extract-plugin
export default {"app-tooltip":"styles_app-tooltip__aXcYU"};